import { LOG_LEVEL_FORMATTERS } from "@constants/texts/formatters";
class ConsoleLogFormatted {
    constructor() {
        this.LOG_LEVELS = {
            info: [
                "bold",
                "dim",
                "underline",
                "invertBackground",
                "hidden",
                "redText",
                "yellowText",
                "log",
            ],
            get warning() {
                return [...this.info, "warning"];
            },
            get error() {
                return [...this.warning, "error"];
            },
        };
        this.shouldPrintMessage = (type) => {
            var _a;
            const logLevel = ((_a = process.env.PLAYDASH_LOG_LEVEL) !== null && _a !== void 0 ? _a : "info");
            const validMethods = this.LOG_LEVELS[logLevel] || [];
            return validMethods.includes(type);
        };
        Object.entries(LOG_LEVEL_FORMATTERS).forEach(([logLevel, ansiFormatter]) => {
            this.createMethod(logLevel, ansiFormatter);
        });
    }
    createMethod(logLevel, ansiFormatter) {
        this[logLevel] = (message) => {
            if (!this.shouldPrintMessage(logLevel))
                return;
            try {
                if (!process.stdout.writable)
                    return;
                process.stdout.write(`\n${ansiFormatter}${message}\x1b[0m\u001b[0m\n\n`, error => {
                    // Handle write errors in the callback
                    if (error &&
                        !["EPIPE", "EIO"].includes(error === null || error === void 0 ? void 0 : error.code)) {
                        // Only log critical errors, ignore broken pipe/IO errors
                        process.stderr.write(`Failed to write to stdout: ${error.message}\n`);
                    }
                });
            }
            catch (error) {
                if (["EPIPE", "EIO"].includes(error === null || error === void 0 ? void 0 : error.code))
                    return;
                throw error;
            }
        };
    }
}
export default new ConsoleLogFormatted();
//# sourceMappingURL=consoleLogFormatted.js.map